import { Auth } from 'aws-amplify';


const refreshToken = () => { Auth.currentSession(); };

export const startRefreshTokenLoop = (timeToLoop = 60000) => {
    setInterval(refreshToken, timeToLoop);
};